import { render, staticRenderFns } from "./WhatsappNewsletterForm.vue?vue&type=template&id=6ea794e2&scoped=true&"
import script from "./WhatsappNewsletterForm.vue?vue&type=script&lang=js&"
export * from "./WhatsappNewsletterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea794e2",
  null
  
)

export default component.exports